<sirius-grid>
    <div
        class="sir-container"
        [ngClass]="textAlignment === 'textLeft' ? 'sir-text-left' : 'sir-text-center'">
        <sirius-heading [text]="title" textStyleCategory="title" textStyleSize="xl"></sirius-heading>
        <sirius-text-html-paragraph [html]="subtitleHtml" textStyleSize="l"></sirius-text-html-paragraph>
    </div>
</sirius-grid>
